import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import productService from '../services/productService';
import ProductCard from './common/ProductCard';
import QuickViewModal from './common/QuickViewModal';

const NewArrivalOne = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Quick View modal state
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showQuickView, setShowQuickView] = useState(false);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 6 } },
            { breakpoint: 1399, settings: { slidesToShow: 4 } },
            { breakpoint: 992, settings: { slidesToShow: 3 } },
            { breakpoint: 575, settings: { slidesToShow: 2 } },
            { breakpoint: 424, settings: { slidesToShow: 1 } },
        ],
    };

    // Quick View handlers
    const handleQuickView = (product) => {
        setSelectedProduct(product);
        setShowQuickView(true);
    };

    const handleCloseQuickView = () => {
        setShowQuickView(false);
        setSelectedProduct(null);
    };

    useEffect(() => {
        const fetchNewProducts = async () => {
            setLoading(true);
            try {
                const response = await productService.getNewProducts(12);
                if (response && response.succeeded) {
                    setProducts(response.products || []);
                } else {
                    console.error('Ürünler yüklenirken hata:', response);
                    setError('Ürünler yüklenirken bir hata oluştu.');
                }
            } catch (err) {
                console.error('Ürünler yüklenemedi:', err);
                setError('Ürünler yüklenirken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };
        fetchNewProducts();
    }, []);

    if (loading) return (
        <div className="container mt-24 text-center">
            <div className="spinner-border text-main-600" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
            </div>
        </div>
    );

    if (error) return (
        <div className="container mt-24">
            <div className="alert alert-danger" role="alert">
                {error}
            </div>
        </div>
    );

    return (
        <>
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading text-center mb-48">
                    <h2 className="mb-12">Yeni Ürünler</h2>
                    <p className="text-neutral-600 mb-0">En yeni eklenen ürünlerimizi keşfedin</p>
                </div>
                {products.length >= 6 ? (
                    <div className="new-arrival__slider arrow-style-two">
                        <Slider {...settings}>
                            {products.map(product => (
                                <div key={product.id} className="px-8">
                                    <ProductCard 
                                        product={product} 
                                        viewMode="slider"
                                        showQuickView={true}
                                        compact={false}
                                        onQuickView={handleQuickView}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                ) : (
                    <div className="row gy-4 g-12">
                        {products.map(product => (
                            <div key={product.id} className="col-xxl-3 col-lg-4 col-sm-6 col-12">
                                <ProductCard 
                                    product={product} 
                                    viewMode="grid"
                                    showQuickView={true}
                                    compact={false}
                                    onQuickView={handleQuickView}
                                />
                            </div>
                        ))}
                    </div>
                )}

                {/* View All Button */}
                <div className="text-center mt-48">
                    <Link 
                        to="/shop" 
                        className="btn btn-main rounded-pill py-16 px-32 text-white fw-semibold transition-2"
                        style={{ 
                            backgroundColor: '#299E60',
                            border: 'none'
                        }}
                    >
                        Tüm Ürünleri Gör
                        <i className="ph ph-arrow-right ms-8"></i>
                    </Link>
                </div>
            </div>

            {/* Quick View Modal */}
            <QuickViewModal
                product={selectedProduct}
                isOpen={showQuickView}
                onClose={handleCloseQuickView}
            />
        </section>
        </>
    );
};

export default NewArrivalOne;